export type KeyString = {
  [key: string]: string
}

export const MONTHS_OBJECT: KeyString = {
  '1': 'Janeiro',
  '2': 'Feverreiro',
  '3': 'Março',
  '4': 'Abril',
  '5': 'Maio',
  '6': 'Junho',
  '7': 'Julho',
  '8': 'Agosto',
  '9': 'Setembro',
  '10': 'Outubro',
  '11': 'Novembro',
  '12': 'Dezembro',
}
